<template>
    <div v-if="msg.answerStatus === 0" class="is-answer-loading">
        <div class="is-answer-loading-text">{{ $t('pc_biz_ai_thinking').d('正在思考') }}</div>
        <div class="answer-loading">
            <div></div>
        </div>
    </div>
    <div v-else-if="msg.answerStatus === 2" class="is-content">{{ msg.contentDetail && msg.contentDetail.content }}
        <yxt-button class="internet-btn" v-if="settings.publicResourceEnabled" type="text" @click="$emit('resend', 'askInternet')">&nbsp;{{ $t('pc_biz_ai_question_tips').d('互联网问问') }}</yxt-button>
    </div>
    <div v-else class="is-content">
        {{ (msg.contentDetail && msg.contentDetail.content) || settings.assistWele || $t('pc_biz_ai_question_default_tips').d('你好，我是AI助手，很高兴为你服务！') }}
    </div>
</template>
<script>
export default {
  name: 'simpleAnswer',
  props: {
    fullscreen: {
      type: Boolean,
      default: false
    },
    msg: { // 回答的消息体
      type: Object,
      default: () => {}
    }
  },
  inject: ['settings'],
  data() {
    return {

    };
  }
};
</script>